import React from 'react';
import { Typography } from '@mui/material';
import { BIO_MAX_LENGTH } from '../../../hooks/useUserProfile';
import CustomTextareaAutosize from '../../../components/common/CustomTextareaAutosize';
import theme from '../../../theme';

const BioField = ({ isEditing, profileForm, handleProfileInputChange }) => {
  const hasBio = Boolean(profileForm?.bio?.trim());

  return isEditing ? (
    <CustomTextareaAutosize
      name="bio"
      value={profileForm?.bio || ''}
      onChange={handleProfileInputChange}
      minRows={4}
      maxLength={BIO_MAX_LENGTH}
      placeholder="자기소개를 입력해주세요"
      sx={{
        padding: '12px 16px',
        color: theme.palette.black[9],
        minHeight: '40px',
      }}
    />
  ) : (
    <Typography
      sx={{
        fontSize: '14px',
        color: hasBio ? theme.palette.black[6] : theme.palette.black[3],
        lineHeight: '1.5',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {hasBio ? profileForm.bio : '자기소개를 입력해주세요'}
    </Typography>
  );
};

export default BioField;
